module.exports = __webpack_public_path__ + "kn.svg?1459b5964fa6b1363d20ae8f6f5fc035";